module.exports = __webpack_public_path__ + "static/media/package-bubble-wrap.488c1287.png";